export function getSafeRedirectUrl(callbackUrl: string, linkUuid: string) {
  const url = new URL(callbackUrl)

  url.searchParams.set('uuid', linkUuid)

  return url.toString()
}
